import { render } from "./HomeStrip.vue?vue&type=template&id=5af61221&scoped=true"
import script from "./HomeStrip.vue?vue&type=script&lang=js"
export * from "./HomeStrip.vue?vue&type=script&lang=js"

import "./HomeStrip.vue?vue&type=style&index=0&id=5af61221&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af61221"]])

export default __exports__